import React, { useContext } from 'react'
import Button from '../../atoms/button/button'
import rombo from '../../../assets/images/rombo.png'
import premioACL from '../../../assets/images/premioACL.png'
import premioBCL from '../../../assets/images/premioBCL.png'
import premioCCL from '../../../assets/images/premioCCL.png'
import { texChanges } from '../../../constants/activity-constants'
import icon1 from '../../../assets/images/iconFlor1.png'
import icon2 from '../../../assets/images/iconFlor2.png'
import icon3 from '../../../assets/images/iconFlor3.png'
import icon4 from '../../../assets/images/iconFlor4.png'
import { siteUrl } from '../../../shared/utils/siteUrl'
import { navigate } from 'gatsby'
import { infoData } from './infoData'
import { Context } from '../../../context/app-context'

import './participaSection.scss'

const ParticipaSection = props => {
  const { mobile } = props
  const { dispatch } = useContext(Context)

  return (
    <div className="f-participaSection-container">
      <div
        id="como-participar"
        className="f-participaSection-container__ancla"
      />
      <div className="f-participaSection-container__wrapper">
        <div className="f-participaSection-container__wrapper__content">
          <div className="f-participaSection-container__wrapper__content__section0">
            <h2 className={process.env.LOCALE}>¿CÓMO PARTICIPAR?</h2>
            {texChanges().comoParticipar}
          </div>
          <div className="f-participaSection-container__wrapper__content__section1">
            {
              //solo mobile muestra icono de la numeracion en flor
              mobile && <img src={icon1} alt="numeracion 1" />
            }
            <h2>
              {process.env.LOCALE === 'es-PY' || process.env.LOCALE === 'es-AR'
                ? 'INICIÁ'
                : 'INICIA'}{' '}
              SESIÓN
            </h2>
            <p>
              ¿Ya{' '}
              {process.env.LOCALE === 'es-AR'
                ? 'formas'
                : process.env.LOCALE === 'es-PY'
                ? 'hacés'
                : 'haces'}{' '}
              parte de NosotrasOnline?
              <br /> Para jugar{' '}
              {process.env.LOCALE === 'es-PY' ? 'debés' : 'debes'}{' '}
              <span>
                <a
                  onClick={() => {
                    dispatch({
                      type: 'set',
                      payload: {
                        modalActive: {
                          type: 'login',
                          props: {
                            close: () => {
                              navigate('/')
                              dispatch({
                                type: 'set',
                                payload: {
                                  modalActive: null,
                                },
                              })
                            },
                            handleSuccess: () => {
                              window.location.reload()
                            },
                          },
                        },
                      },
                    })
                  }}
                >
                  Iniciar sesión{' '}
                </a>
              </span>
              en Nosotras <br />
              Online. Si {process.env.LOCALE === 'es-AR' ? 'todavía' : 'aún'} no
              estás registrada
            </p>
            <h3>¡TRANQUILA!</h3>
            <Button
              text={
                process.env.LOCALE === 'es-PY'
                  ? 'REGISTRATE ACÁ'
                  : 'REGÍSTRATE AQUÍ'
              }
              size="w250"
              onClick={() => {
                window.open(
                  siteUrl + '/registro/fecha-de-nacimiento/',
                  '_blank'
                )
              }}
            />
            {process.env.LOCALE === 'es-PR' && (
              <h3
                style={{
                  maxWidth: '597px',
                  textAlign: 'center',
                  letterSpacing: '0.2rem',
                }}
              >
                ¡Juega las veces que quieras, acumula puntos y gánate un
                espectacular Kit de Nosotras!
              </h3>
            )}
          </div>
          {process.env.LOCALE === 'es-PR' ||
          process.env.LOCALE === 'es-BO' ? null : (
            //muestra esto si NO es PR
            <div className="f-participaSection-container__wrapper__content__section2">
              {
                //solo mobile muestra icono de la numeracion en flor
                mobile && <img src={icon2} alt="numeracion 2" />
              }
              {texChanges().redimir}
              <Button
                text={
                  process.env.LOCALE === 'es-AR' ||
                  process.env.LOCALE === 'es-PY'
                    ? 'ACÁ'
                    : 'AQUÍ'
                }
                size="w140"
                onClick={() => {
                  window.open(
                    siteUrl + '/mis-puntos/ingreso-de-claves/',
                    '_blank'
                  )
                }}
              />
            </div>
          )}
          <div
            className={`f-participaSection-container__wrapper__content__section3 ${process.env.LOCALE}`}
          >
            {
              //solo mobile muestra icono de la numeracion en flor
              mobile && (
                <img
                  src={
                    process.env.LOCALE === 'es-PR' ||
                    process.env.LOCALE === 'es-BO'
                      ? icon2
                      : icon3
                  }
                  alt="numeracion 3"
                />
              )
            }
            <h2>
              {process.env.LOCALE === 'es-AR' || process.env.LOCALE === 'es-PY'
                ? 'JUGÁ'
                : 'JUEGA'}
            </h2>
            {texChanges().juega}
          </div>
          <div
            className={`f-participaSection-container__wrapper__content__section4 ${process.env.LOCALE}`}
          >
            {infoData.map(item => (
              <div className="f-participaSection-container__wrapper__content__section4__item">
                <img src={rombo} alt="viñeta rombo morada" />
                <p>{item}</p>
              </div>
            ))}
          </div>
          <h2 className="title1">¿ESTÁS PREPARADA?</h2>
          <Button
            text="¡A JUGAR!"
            size="w140"
            onClick={() => navigate('/juega')}
          />
          <div
            className={`f-participaSection-container__wrapper__content__section5 ${process.env.LOCALE}`}
          >
            {
              //solo mobile muestra icono de la numeracion en flor
              mobile && (
                <img
                  src={
                    process.env.LOCALE === 'es-PR' ||
                    process.env.LOCALE === 'es-BO'
                      ? icon3
                      : icon4
                  }
                  alt="numeracion 4"
                />
              )
            }
            <h2>
              {process.env.LOCALE === 'es-AR' || process.env.LOCALE === 'es-PY'
                ? 'GANÁ'
                : 'GANA'}
            </h2>
            {process.env.LOCALE === 'es-CO' ||
            process.env.LOCALE === 'es-AR' ||
            process.env.LOCALE === 'es-PY' ||
            process.env.LOCALE === 'es-PR' ||
            process.env.LOCALE === 'es-BO' ||
            process.env.LOCALE === 'es-DO'
              ? texChanges().gana
              : null}
          </div>
          <div className="f-participaSection-container__wrapper__content__section6">
            <div className="f-participaSection-container__wrapper__content__section6__top">
              {process.env.LOCALE === 'es-CL' ? ( //esto es porque chile puso 3 columnas
                <>
                  <div className="f-participaSection-container__wrapper__content__section6__top__premio">
                    <h3>
                      EL MEJOR PUNTAJE <span>GANARA</span>
                    </h3>
                    <p>
                      Un kit para cejas de Anastasia Beverly Hills y una paleta
                      de sombras de Huda Beauty
                    </p>
                    <img src={premioACL} alt="premio chile" />
                  </div>
                  <div className="f-participaSection-container__wrapper__content__section6__top__premio">
                    <h3>
                      EL SEGUNDO Y TERCER LUGAR <span>GANARÁN</span>
                    </h3>
                    <p>Un kit de cejas de Anastasia Beverly Hills</p>
                    <img src={premioBCL} alt="premio chile" />
                  </div>
                  <div className="f-participaSection-container__wrapper__content__section6__top__premio">
                    <h3>
                      DEL TOP 4 AL 10 <span>GANARÁN</span>
                    </h3>
                    <p>Un kit de productos Nosotras</p>
                    <img src={premioCCL} alt="premio chile" />
                  </div>
                </>
              ) : (
                texChanges().premios
              )}
            </div>
            <div className="f-participaSection-container__wrapper__content__section6__bot">
              {process.env.LOCALE !== 'es-BO' && (
                <p>
                  Antes de jugar, te recomendamos conocer todos los{' '}
                  <span>
                    <a href="#terminos-y-condiciones">
                      términos y condiciones aquí
                    </a>
                  </span>
                </p>
              )}
              {texChanges().antes}
              <Button
                text="¡QUIERO JUGAR!"
                size="w250"
                onClick={() => navigate('/juega')}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ParticipaSection
